import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuperBidButtonRoutingModule } from './super-bid-button-routing.module';
import { SuperBidButtonComponent } from './super-bid-button.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    SuperBidButtonComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SuperBidButtonRoutingModule
  ],
  exports: [
    SuperBidButtonComponent
  ],
})
export class SuperBidButtonModule { }
